import { savePetThunk } from 'actions/pets/PetsActions';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { Pet, SavePet } from 'types/Pet';
import {
    ONLINE_BOOKING_ERROR,
    ONLINE_BOOKING_SAVE_PET_START,
    ONLINE_BOOKING_SAVE_PET_SUCCESS,
    ONLINE_BOOKING_SET_SELECTED_PETS,
    OnlineBookingAction
} from 'actions/onlineBooking/OnlineBookingActionsTypes';

export const saveOnlineBookingPetThunk = (
    petData: SavePet
): ThunkAction<Promise<Pet>, RootState, null, RootAction> => {
    return async dispatch => {
        try {
            dispatch({
                type: ONLINE_BOOKING_SAVE_PET_START
            });

            const savedPet = await dispatch(savePetThunk(petData));

            dispatch({
                type: ONLINE_BOOKING_SAVE_PET_SUCCESS,
                payload: {
                    pet: savedPet
                }
            });

            return savedPet;
        } catch (error) {
            dispatch({ type: ONLINE_BOOKING_ERROR });

            throw error;
        }
    };
};

export const setOnlineBookingSelectedPets = (pets: Array<Pet>): OnlineBookingAction => ({
    type: ONLINE_BOOKING_SET_SELECTED_PETS,
    payload: { pets }
});
